



































































import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { user } from '../fire'
import * as Interface from '../../functions/interfaces'


export default Vue.extend({
    mounted() {
        this.fetch()
    },


    data() {
        return {
            user: user,
            projects: [] as Array<Interface.Project>
        }
    },


    computed: {
        isAdmin() {
            if (this.user && this.user.admin)
                return 'long'
            else return ''
        }
    },


    methods: {
        fetch: async function() {
            
            // Fetch
            try { await firebase.firestore().collection('projects').where('active', '==', true).onSnapshot((snap) => {
                this.projects = []
                for (const doc of snap.docs) {
                    const project = doc.data()! as unknown as Interface.Project
                    project.id = doc.id
                    const target = project.target.toString()
                    project.target = target
                    this.projects.push(project)
                }
            })}
            catch(error) { console.log('Unable to fetch event'), error; alert(error.message) }
        },


        // date(timestamp) {
        //     const date = new Date(timestamp.seconds * 1000)
        //     return date.toLocaleDateString(this.$locale())
        // },


        open(alias: string) {
            this.$router.push({name: 'project', params: {alias: alias}})
        },


        edit(id: string) {
            this.$router.push({name: 'edit', params: {id: id}})
        },

        stats(id: string) {
            this.$router.push({name: 'stats', params: {id: id}})
        },
    }
})
